import React, { useRef, useMemo } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../../../../common/config';
import Container from '../Container';
import { getVh } from '../utils';
import useTriggerAnimation from '../useTriggerAnimation';

const Flower = styled.img`
  aspect-ratio: 1308/3014;
  width: auto;
  height: 120vh;

  transform: translateX(-50%) rotateY(180deg);

  @media screen and (min-width: ${viewport.md}) {
    transform: translateX(-30%) rotateY(180deg);
  }
`;

const Sunflower = () => {

  const ref = useRef<HTMLElement>(null);
  const top = useMemo(() => getVh("buffer", 0.2), []);

  useTriggerAnimation(ref, top);

  return (
    <Container
      ref={ref}
      top={top}
      style={{ left: "0" }}
    >
      <Flower src="/static/images/outline/sunflower.png" />
    </Container>
  );
}

export default Sunflower;